/* eslint-disable import/prefer-default-export */

export const domain = window.location.hostname as string;
